import IconClose from 'approot/shared/icons/icon-close';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';

type Props = {
  onClick: () => void;
};

const TTSCloseButton = ({ onClick }: Props) => {
  return (
    <SecondaryButtonIcon
      type="button"
      $isSmall
      $borderRadius={40}
      aria-label="Close text to speech"
      onClick={onClick}
    >
      <IconClose width={20} height={20} />
    </SecondaryButtonIcon>
  );
};

export default TTSCloseButton;
